import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, CONTACT, NAV_LINKS } from "../../data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `px-4 py-2 font-bold uppercase tracking-wide text-sm transition-colors border-b-2 ${
      isActive
        ? "text-black border-[#E62117]"
        : "text-zinc-700 border-transparent hover:text-black hover:border-black"
    }`;

  return (
    <nav
      data-testid="site-nav"
      className="bg-white border-b-2 border-black sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Andstel Group"
              className="h-12 w-auto object-contain"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testId}
                className={linkClass}
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="nav-phone-link"
              className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider hover:text-[#E62117] transition-colors"
            >
              <Phone size={16} />
              {CONTACT.phone}
            </a>
            <Link
              to="/contact"
              data-testid="nav-cta-quote"
              className="btn-primary text-sm px-6 py-3"
            >
              Get a Quote
            </Link>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 border-2 border-black"
            aria-label="Toggle navigation"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t-2 border-black bg-white"
        >
          <div className="flex flex-col p-4 gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testId}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 font-bold uppercase tracking-wide text-sm border-2 ${
                    isActive
                      ? "bg-black text-white border-black"
                      : "border-transparent hover:border-black"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-cta-quote-mobile"
              className="btn-primary mt-2 text-sm"
            >
              Get a Quote
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
